module.exports = __webpack_public_path__ + "img/left-vip-bg-6daa9c4b.b198a939.png";